export function RightPanel() {
  // Right panel removed - AI suggestions no longer displayed
  return null;
}
